/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramAuthControllerAuthorizeByCredentialsMutationRequest,
  TelegramAuthControllerAuthorizeByCredentialsMutationResponse,
  TelegramAuthControllerAuthorizeByCredentials401,
  TelegramAuthControllerAuthorizeByCredentials403,
} from '../types/TelegramAuthControllerAuthorizeByCredentials.ts';

function getTelegramAuthAuthorizeByCredentialsUrl() {
  const res = { method: 'POST', url: `/api/telegram/auth/credentials/login` as const };
  return res;
}

/**
 * {@link /api/telegram/auth/credentials/login}
 */
export async function telegramAuthAuthorizeByCredentials(
  data: TelegramAuthControllerAuthorizeByCredentialsMutationRequest,
  config: Partial<RequestConfig<TelegramAuthControllerAuthorizeByCredentialsMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramAuthControllerAuthorizeByCredentialsMutationResponse,
    ResponseErrorConfig<
      TelegramAuthControllerAuthorizeByCredentials401 | TelegramAuthControllerAuthorizeByCredentials403
    >,
    TelegramAuthControllerAuthorizeByCredentialsMutationRequest
  >({
    method: 'POST',
    url: getTelegramAuthAuthorizeByCredentialsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
